import { BaseDto } from './base.dto';

export class FireAlarmComponentDto extends BaseDto {
  type?: string;
  model?: string;
  manufacture?: string;
}
